/**
 * Project: fuse-react-app
 * FilePath: /src/client/app/services/app.service.js
 * File: app.service.js
 * Created Date: Sunday, January 20th 2019, 2:47:07 pm
 * Author: Craig Bojko (craig.bojko@anexsys.com)
 * -----
 * Last Modified: Mon Feb 04 2019
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2019 Anexsys
 * ------------------------------------
 */

import { rpc } from './lib/socketEngine.js'
import jwtService from 'modules/auth/jwtService'

export const SERVICE = 'APP'

export async function resolveApp () {
  try {
    const token = jwtService.getAccessToken()
    if (!token) {
      throw new Error(`No JWT supplied to ${SERVICE} service`)
    }

    const socketRequest = () => {
      return rpc('resolveApp', {
        token
      })
    }

    const appResolution = await socketRequest()
    if (Error.isError(appResolution) && appResolution.message && ~appResolution.message.indexOf('2 UNKNOWN')) {
      console.warn(`Error returned from socket: ${appResolution.message}`)
      return await socketRequest()
    }
    return appResolution
  } catch (error) {
    throw new Error(error.message)
  }
}
